
import {Injectable, Inject} from 'ng-metadata/core';
import {HttpService} from '../../infra/httpRequest/http.service';
import {Cheetah} from '../cheetah.service';
import {SearchStateService} from '../searchState.service';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';

const indexOf = require('lodash/indexOf');
const assign = require('lodash/assign');
const getValue = require('lodash/get');


@Injectable()

export class SnippetService {
    private _snippets;
    private _highlight;
    constructor(private httpService : HttpService,
                @Inject('restBaseURLs') private restBaseURLs,
                private cheetah: Cheetah,
                private searchStateService : SearchStateService,
                
                private configurationUtil : ConfigurationUtil) {
    }
    
    get snippets() {
        return this._snippets;
    }
    
    set snippets(snippets) {
        this._snippets = snippets;
    }
 
    get highlights() {
        return this._highlight;
    }

    public updateSnippets(items, highlights) {
        if (!items) {
            return;
        }
        if (!this.configurationUtil.getBriefResultConfiguration()) {
            return;
        }
        if (!this.configurationUtil.getBriefResultConfiguration().showsnip) {
            return;
        }

        this._snippets = {};
        items = this.handleItemsWithSnippetsInResponse(items);
        let records = items.map((item, index, array) => this.getFieldsFromPnxAsArray(item));
        records = records.filter(this.filterByContexts);
        records = records.filter(this.filterOutCdiRecords);
        if (records.length === 0) {
            if (highlights && highlights.snippet){
                this._highlight = highlights.snippet;
            }
            return;
        }

        this.httpService.callPostAndParams(this.restBaseURLs.snippetURL, this.cheetah.searchData, records)
               .then((data: any) => {

            assign(this._snippets, data);
            let hterms = data.highlight;
            this._highlight = hterms ? hterms.substring(1, hterms.length - 1).split(",") : undefined;
        });
    }
    
    private handleItemsWithSnippetsInResponse(items){
    	const itemsWithoutSnippets = [];
    	for (let item of items){
            const snippet = getValue(item, 'pnx.display.snippet');
    		if (snippet) {
                const recordId = item.pnx.control.recordid[0];
	    		this.snippets[recordId] = snippet[0];
    		} else {
    			itemsWithoutSnippets.push(item);
    		}
    	}
    	return itemsWithoutSnippets;
    }
    
    private getFieldsFromPnxAsArray(item) {
        let rsrctype = getValue(item, 'pnx.search.rsrctype');
        if (rsrctype && rsrctype.length>0) {
        	rsrctype = rsrctype[0];
        }
        return {context: item.context,
                recordId: item.pnx.control.recordid[0],
                resourceType: rsrctype};
    }
    
    private filterByContexts(e) {
         return (e.context === 'L' || e.context === 'PC');
    }

    private filterOutCdiRecords(e){
        return !e.recordId.startsWith("cdi_");
    }
    
}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/snippet/snippet.service.ts